var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35714 15.6429L5.71317 16.2868L6.35714 16.9308L7.00112 16.2868L6.35714 15.6429ZM7.26786 1.07144C7.26786 0.568462 6.86012 0.160722 6.35714 0.160722C5.85417 0.160722 5.44643 0.568462 5.44643 1.07144L7.26786 1.07144ZM0.856027 11.4297L5.71317 16.2868L7.00112 14.9989L2.14397 10.1418L0.856027 11.4297ZM7.00112 16.2868L11.8583 11.4297L10.5703 10.1418L5.71317 14.9989L7.00112 16.2868ZM7.26786 15.6429L7.26786 1.07144L5.44643 1.07144L5.44643 15.6429L7.26786 15.6429Z",
    fill: "url(#paint0_linear_7022_32418)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7022_32418",
    x1: 6.35715,
    y1: 15.6429,
    x2: 6.35714,
    y2: 1.07144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadMessage);
export default __webpack_public_path__ + "static/media/read_message.c7511cfbe4effcd99cf68058be335f69.svg";
export { ForwardRef as ReactComponent };